import React from 'react';
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export function Skeleton({
    className,
    ...props
}) {
    return (
        <div
            className={cn("animate-pulse rounded-md bg-stone-200/60", className)}
            {...props}
        />
    )
}

// ─── Pre-built Skeletons for common UI patterns ──────────────────────────────

export function TableSkeleton({ rows = 5, columns = 4 }) {
    return (
        <div className="w-full space-y-4">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <Skeleton className="h-8 w-[200px]" />
                <Skeleton className="h-9 w-[150px]" />
            </div>

            {/* Table Body */}
            <div className="rounded-md border border-stone-200">
                {/* Header row */}
                <div className="bg-stone-50 border-b border-stone-200 flex p-4">
                    {Array.from({ length: columns }).map((_, i) => (
                        <Skeleton key={i} className="h-4 w-full mx-2 max-w-[100px]" />
                    ))}
                </div>
                {/* Rows */}
                <div className="divide-y divide-stone-100">
                    {Array.from({ length: rows }).map((_, i) => (
                        <div key={i} className="flex p-4 items-center">
                            {Array.from({ length: columns }).map((_, j) => (
                                <div key={j} className="flex-1 mx-2">
                                    <Skeleton className="h-4 w-[80%]" />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export function CardGridSkeleton({ count = 4 }) {
    return (
        <div className="w-full space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {Array.from({ length: count }).map((_, i) => (
                    <div key={i} className="bg-white p-6 rounded-sm border border-stone-200 shadow-sm">
                        <div className="flex justify-between items-start mb-4">
                            <Skeleton className="h-4 w-20" />
                            <Skeleton className="h-10 w-10 rounded-sm" />
                        </div>
                        <Skeleton className="h-8 w-16 mb-2" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export function FormSkeleton({ fields = 4 }) {
    return (
        <div className="space-y-4 max-w-2xl mx-auto p-6 bg-white rounded-lg border border-stone-200">
            <Skeleton className="h-6 w-1/3 mb-6" />
            {Array.from({ length: fields }).map((_, i) => (
                <div key={i} className="space-y-2">
                    <Skeleton className="h-4 w-1/4" />
                    <Skeleton className="h-10 w-full" />
                </div>
            ))}
            <div className="pt-4 flex justify-end">
                <Skeleton className="h-10 w-24" />
            </div>
        </div>
    )
}
